import { Parallax } from "react-scroll-parallax";

import GroupTitlePage from "@/components/shared/GroupTitlePage";

import CustomImage from "../shared/CustomImage";

interface BannerTitleProps {
  bannerUrl: string;
  title: string;
  desc: string;
}

export default function BannerTitle({
  bannerUrl,
  title,
  desc,
}: BannerTitleProps) {
  return (
    <>
      <div className="absolute -z-10 flex min-h-[75vh] w-full items-center justify-center overflow-hidden after:absolute after:inset-0 after:bg-primary-800/85">
        <Parallax
          speed={-200}
          className="absolute inset-0 my-auto h-screen bg-primary-500"
        >
          <div>
            <CustomImage
              src={bannerUrl}
              alt="banner"
              fill
              className="z-0 object-cover object-center"
              priority
            />
          </div>
        </Parallax>
      </div>
      <section className="relative flex w-full items-center justify-center overflow-hidden pb-20 pt-40 lg:pb-40 lg:pt-60">
        <div className="relative z-10 flex w-full flex-col items-center justify-center">
          <GroupTitlePage title={title} desc={desc} />
        </div>
      </section>
    </>
  );
}
